import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Pembayaransekolah: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi Pembayaran Sekolah" />
    <h1><strong><a href="/pembayaransekolah/">Aplikasi Pembayaran Sekolah</a></strong></h1>
    <div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/MPSbEsWbIbc" title="Aplikasi Pembayaran Sekolah"></iframe>
</div>
    <p>
Hadirnya aplikasi pembayaran uang sekolah ini semakin memudahkan admin dalam bekerja untuk kebutuhan pencatatan dan pembukuan keuangan sekolah.
    </p>
<p>Fitur : Master database untuk memasukan data akun kebutuhan akan pembayaran siswa di sekolah , daftar siswa untuk master data dalam pendataan siswa yang memudahkan nanti pada saat melakukan pembayaran keuangan , invoice fitur untuk menerbitkan tagihan pembayaran terkait keuangan sekolah , pembayaran menu untuk melakukan dan mencatat pembayaran siswa dan kebutuhan untuk sekolah , laporan untuk cek jumlah uang yang masuk di sekolah via pencatatan pembayaran.</p>
<div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/7StjxD98At8" title="Aplikasi Pembayaran Sekolah"></iframe>
</div>
<p>Semakin mudah dengan dukungan APK android dalam bekerja untuk mobilitas pada aktivitas belajar mengajar</p>
<p>daftar harga layanan per tahun : 
<br/>Pembayaran sekolah Apps
<br/>Free Domain .sch.id
<br/>Web Space 1.5GB
<br/>Include Host
<br/>axcora school cms website
<br/>website sekolah
<br/>APK Android Guru
<br/>APK Android Siswa
<br/>Rp.2.512.300</p>
<a href="https://wa.me/6285646104747?text=Axcoraapps%20saya%20mau%20order%20Webapp%0ANama/sekolah%20%3A%0AAlamat%20%3A%0APaketwebapp%20paymentappsstandard%3A%0APrice%20%3ARp.2.512.300/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0ABRI%20008601112564504%20Soni%20Andrias%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Order Now</a>
<br/>    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Pembayaransekolah

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
